import React from "react";
import { Field, reduxForm } from "redux-form";
import ValidatedInputField from "../../common/form/ValidatedInputField";
import { validate } from "./validate.js";
import SubmitButton from "../../common/SubmitButton";
import { injectIntl } from "react-intl";
import afterSubmitFail from "../../common/form/focusAfterSubmitFail";
import ResetButton from "../../common/ResetButton";

class CategoryForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { handleSubmit, handleReset, isUpdate } = this.props;

        return (
            <form onSubmit={handleSubmit} noValidate={true}>
                <Field
                    type="text"
                    name="name"
                    component={ValidatedInputField}
                    placeholder="Navn"
                    className="form-control"
                    label="Navn"
                />

                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={isUpdate} />
                            <ResetButton onClick={handleReset} />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

CategoryForm = reduxForm({
    form: "rent-machine-category",
    validate,
    onSubmitFail: afterSubmitFail
})(CategoryForm);

export default injectIntl(CategoryForm);


// WEBPACK FOOTER //
// ./web/src/components/rent-machine/category/CategoryForm.jsx